import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class IdempotencyService {
    private keys = new Map<string, string>();
    private inFlight = new Map<string, Promise<any>>();

    getOrCreate(operation: string): string {
        const existing = this.keys.get(operation);
        if (existing) {
            return existing;
        }

        const key = crypto.randomUUID();
        this.keys.set(operation, key);
        return key;
    }

    clear(operation: string): void {
        this.keys.delete(operation);
        this.inFlight.delete(operation);
    }

    /**
    * ถ้ามี call เดิมกำลังทำงานอยู่ (operation เดียวกัน)
    * call ที่เข้ามาซ้ำจะได้ผลลัพธ์เดียวกับ call แรก แทนที่จะยิง fn() ซ้ำ
    */
    run<T>(operation: string, fn: () => Promise<T>): Promise<T> {
        const existing = this.inFlight.get(operation);
        if (existing) {
            return existing as Promise<T>;
        }

        const promise = fn().finally(() => {
            this.inFlight.delete(operation);
        });

        this.inFlight.set(operation, promise);
        return promise;
    }
}
